export const IMG_BASE = 'https://picsum.photos';
export const CAROUSEL_INTERVAL = 5000;

/** Calm, professional images for service cards (by slug). */
export const DEFAULT_SERVICE_IMAGES: Record<string, string> = {
  'web-development':
    'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80',
  'mobile-app':
    'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&q=80',
  'creative-design-uiux':
    'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=600&q=80',
  consulting:
    'https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&q=80',
  'maintenance-and-support':
    'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600&q=80',
  'ai-futuristic':
    'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&q=80',
  'game-development':
    'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=600&q=80',
  'original-products-solutions':
    'https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=600&q=80',
};

/** Fallback images for Our Work projects when imageUrl is empty (by slug). */
export const DEFAULT_PROJECT_IMAGES: Record<string, string> = {
  'arkron-platform':
    'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
  'native-experience':
    'https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&q=80',
  'smart-systems':
    'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80',
};

export function getServiceImageUrl(service: { slug: string; imageUrl?: string }): string {
  return service.imageUrl?.trim() || DEFAULT_SERVICE_IMAGES[service.slug] || '';
}

export const iconSvg: Record<string, string> = {
  web: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>',
  mobile: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>',
  design: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 19l7-7 3 3-7 7-3-3z"/><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"/></svg>',
  consulting: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.65 9.25a2.9 2.9 0 0 1 5.7.6c0 1.85-1.9 2.55-2.95 3.36-.62.48-.75.85-.75 1.44"/><circle cx="12" cy="16.9" r="0.65" fill="currentColor" stroke="none"/></svg>',
  support: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>',
  ai: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/></svg>',
  game: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 10h12a4 4 0 0 1 3.8 5.2l-1.1 3.3a2 2 0 0 1-3 1.1L15 18H9l-2.7 1.6a2 2 0 0 1-3-1.1l-1.1-3.3A4 4 0 0 1 6 10z"/><line x1="8" y1="14" x2="8" y2="16"/><line x1="7" y1="15" x2="9" y2="15"/><circle cx="16.5" cy="14.5" r="1"/><circle cx="18.5" cy="16.5" r="1"/></svg>',
  product: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2l8 4.5v11L12 22l-8-4.5v-11L12 2z"/><path d="M12 2v20"/><path d="M4 6.5l8 4.5 8-4.5"/></svg>',
};

/** Curated industry images by slug (avoid random placeholders). */
export const DEFAULT_INDUSTRY_IMAGES: Record<string, string> = {
  'ai-futuristic-ml':
    'https://images.unsplash.com/photo-1717444308814-0e917f33e6b6?auto=format&fit=crop&fm=jpg&ixlib=rb-4.1.0&q=80&w=1200',
  agriculture:
    'https://images.unsplash.com/photo-1720156457517-c5ae8b9915f0?fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.1.0&q=80&w=1200',
  'real-estate':
    'https://images.unsplash.com/photo-1757264141891-132e7a714ab4?auto=format&fit=crop&fm=jpg&ixlib=rb-4.1.0&q=80&w=1200',
  'social-networking':
    'https://cdn.pixabay.com/photo/2018/07/13/09/30/network-3535305_1280.jpg',
  'retail-ecommerce':
    'https://images.unsplash.com/photo-1573552991725-c7b115591d04?auto=format&fit=crop&fm=jpg&ixlib=rb-4.1.0&q=80&w=1200',
  gaming:
    'https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&fm=jpg&ixlib=rb-4.1.0&q=80&w=1200',
};

/** Signature "Who we are" image (ancient engineering, no people). */
export const WHO_WE_ARE_IMAGE =
  'https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Roman_aqueduct_Tarragona.jpg/960px-Roman_aqueduct_Tarragona.jpg';

/** Home "Let's collaborate" image (alliance/partnership vibe). */
export const CONTACT_IMAGE =
  'https://cdn.pixabay.com/photo/2023/06/14/12/30/hands-8062985_1280.jpg';
